import type { TranslationTree } from '../../types';

export const adminTools: TranslationTree = {
  adminTools: {
    tab: 'Werkzeuglöschung',
    title: 'Werkzeugverwaltung',
    subtitle:
      'Löschen Sie Werkzeuge oder ganze Referenzen Ihres Unternehmens. Löschungen sind endgültig und entfernen die Bearbeitungsspuren jedes gelöschten Werkzeugs.',
    loading: 'Werkzeuge werden geladen…',
    summary: {
      references: '{{count}} Referenzen',
      tools: '{{count}} Werkzeuge',
      unreferenced: '{{count}} Werkzeuge ohne Referenz',
    },
    group: {
      count: '{{count}} Werkzeuge',
      alias: 'Alias: „{{alias}}“',
    },
    unreferenced: {
      title: 'Werkzeuge ohne Referenz — nur einzeln löschbar',
    },
    dates: {
      line: 'erstellt {{created}} · aktualisiert {{updated}}',
      none: 'keine Spuren',
    },
    actions: {
      deleteTool: 'Löschen',
      deleteReference: 'Referenz löschen',
      retry: 'Erneut versuchen',
    },
    dialog: {
      cancel: 'Abbrechen',
      tool: {
        title: 'Werkzeug {{toolId}} löschen?',
        description:
          'Dies löscht das Werkzeug {{toolId}} und alle seine Bearbeitungsspuren. Dies kann nicht rückgängig gemacht werden.',
        confirm: 'Werkzeug löschen',
      },
      reference: {
        title: 'Referenz {{reference}} löschen?',
        description:
          'Dies löscht die {{count}} Werkzeuge der Referenz {{reference}}, alle ihre Bearbeitungsspuren sowie den Referenz-Alias. Dies kann nicht rückgängig gemacht werden.',
        descriptionAliasOnly:
          'Die Referenz {{reference}} hat keine Werkzeuge — dies löscht ihren Alias-Eintrag. Dies kann nicht rückgängig gemacht werden.',
        confirm: 'Referenz löschen',
      },
    },
    error: {
      generic: 'Das Löschen ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
    },
  },
};
